<mat-horizontal-stepper class="HorizontalStepper" [linear]=true
  disableRipple="true" #stepper>
  <mat-step [stepControl]="NewRequestForm" [editable]="isEditable">
    <ng-template matStepLabel>{{"stpr_Request" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</ng-template>
    <app-new-req-form (submitFormular)="updateRequestModel()"
      [childFormInput]="NewRequestForm"></app-new-req-form>
  </mat-step>
  <mat-step [stepControl]="CoordinateSearchForm" [editable]="isEditable">
    <ng-template matStepLabel>{{"stpr_CoordinateSearch" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
    </ng-template>
    <app-coordinate-search-page (submitFormular)="updateRequestModel(true)"
      [CoordinateSearchFormGroup]="CoordinateSearchForm"></app-coordinate-search-page>
  </mat-step>
  <mat-step *ngIf="MapOrManualRequestDisplay == 'Map'" [stepControl]="MapForm" [editable]="isEditable" >
    <ng-template matStepLabel>{{"stpr_Map" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}</ng-template>
    <app-map-page (submitFormular)="updateRequestModel(true)" [stepper]="stepper" [childFormInput]="MapForm">
    </app-map-page>
  </mat-step>
  <mat-step *ngIf="MapOrManualRequestDisplay == 'Manual'" [editable]="isEditable">
    <ng-template matStepLabel>{{"stpr_ManualRequest" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
    </ng-template>
    <app-manual-request (submitFormular)="updateRequestModel()"></app-manual-request>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel (click)="mapValidate()">{{"stpr_RequestOverview" | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "Common"}}
    </ng-template>
    <app-request-overview [childFormInput]="OverviewForm" (onSubmit)="disableEditable()">
    </app-request-overview>
  </mat-step>
</mat-horizontal-stepper>

<div style="display:none;" id="MapConfig">{{MapConfig | json}}</div>
<div style="display:none;" id="MapOptions">{{MapOptions | json}}</div>
<div style="display:none;" id="MapText">{{MapText | json}}</div>
<div style="display:none;" id="MapServicesUrl">{{MapServicesUrl | json}}</div>
